import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as DictionaryIcon } from "icons/Dictionary.svg";
import { ReactComponent as FolderIcon } from "icons/Folder.svg";
import { ReactComponent as HelpIcon } from "icons/Help.svg";
import { ReactComponent as HomeIcon } from "icons/Home.svg";
import { ReactComponent as ReportsIcon } from "icons/Reports.svg";
import { ReactComponent as SettingsIcon } from "icons/Settings.svg";
import { ReactComponent as SystemAdminIcon } from "icons/SystemAdmin.svg";
import { ReactComponent as UserAdminIcon } from "icons/UserAdministration.svg";
import SidebarOption from "layout/sidebar/SidebarOption";

const SideBar = () => {
  // eslint-disable-next-line no-undef
  const { roles, location } = UserInfo;
  // eslint-disable-next-line no-undef
  const { hasLicenseExpired } = Application;

  const isSystemAdmin = roles?.includes("system_admin");
  const isUserAdmin = roles?.includes("user_admin");
  const isLicensedUser =
    roles?.includes("user,") || roles?.endsWith(",user") || roles === "user";

  const { navBarAndSideBarDisabled } = useSelector((state) => state.app);

  return (
    <div className="react__sidebar" data-testid="sidebar">
      <div className="react__sidebar__buttons_container">
        {isLicensedUser && !hasLicenseExpired && (
          <>
            <SidebarOption
              content={<HomeIcon width={18} height={18} />}
              onClick={() => {
                window.location.href = "../../../../..";
              }}
              hover="Home"
            />
            <SidebarOption
              content={<FolderIcon />}
              onClick={() => {
                window.location.href = "/#folders";
              }}
              hover="Folders"
            />
            <SidebarOption
              content={<DictionaryIcon />}
              onClick={() => {
                window.location.href = "/dictionaries";
              }}
              hover="Dictionaries"
              selected={location === "Dictionaries"}
            />
            <SidebarOption
              content={<ReportsIcon />}
              onClick={() => {
                window.location.href = "/#reports";
              }}
              hover="Reports"
            />
            <SidebarOption
              content={<HelpIcon />}
              onClick={() => {
                window.location.href = "/help";
              }}
              hover="Help"
              selected={location === "Help"}
            />
          </>
        )}
      </div>
      <div className="react__sidebar__buttons_container">
        {isSystemAdmin && (
          <SidebarOption
            content={<SystemAdminIcon />}
            onClick={() => {
              window.location.href = "/systemAdmin";
            }}
            hover="System Admin"
            selected={location === "System Admin"}
          />
        )}
        {!isSystemAdmin && isUserAdmin && (
          <SidebarOption
            content={<UserAdminIcon />}
            onClick={() => {
              window.location.href = "/users/#/users";
            }}
            hover="Users"
            selected={location === "User Admin"}
          />
        )}
        {isLicensedUser && !hasLicenseExpired && (
          <SidebarOption
            content={<SettingsIcon className="settings_icon" />}
            onClick={() => {
              window.location.href = "/settings";
            }}
            hover="Settings"
            selected={location === "Settings"}
          />
        )}
      </div>
      {navBarAndSideBarDisabled && (
        <div
          className="react__sidebar__disable_mask"
          data-testid="disable-mask"
        />
      )}
    </div>
  );
};

export default SideBar;
